module.exports = [
	{
		"value": "1"
	},
	{
		"value": "2"
	},
	{
		"value": "3"
	},
	{
		"value": "4"
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/data/digits.json
 ** module id = 314
 ** module chunks = 0
 **/